<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-printer-3d-nozzle</v-icon>{{$t('profile.nozzle.nozzlesout')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <NozzleOutForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import NozzleOutForm from '../../components/nozzleout/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'NozzleOut';

const { mapFields } = createHelpers({
  getterType: 'nozzleout/getField',
  mutationType: 'nozzleout/updateField'
});

export default {
  name: 'NozzleOutCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    NozzleOutForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('nozzleout', ['create', 'reset'])
  }
};
</script>
